import React, { FC, Ref, useRef } from 'react'
import { Popup } from '../../catalog/Popup'
import styled from 'styled-components'
import { ViewState } from '../deposit/DepositState'
import { extractErrorMessage } from '../../../logic/errors/extract-error-message'
import ValidationButton from '../../catalog/ValidationButton'
import { ErrorMessage } from '../../catalog/ErrorMessage'
import { EmptyLine } from '../../catalog/EmptyLine'

interface Props {
  state: ViewState
  onExit: VoidFunction
}

export const FailWithdrawPopup: FC<Props> = (props: Props) => {
  const { state } = props

  const message =
    (state.subState && state.subState.message) || 'Transaction cancelled'

  return (
    <div>
      <ErrorMessage className="mt20">{message}</ErrorMessage>
    </div>
  )
}

// TODO: include this in the Popup component
const PopupWrapper = styled.div`
  font-size: 0.85em;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
`
